(function () {
    'use strict';

    const page = document.querySelector('.rb-sales-page');
    if (!page) {
        return;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const header = document.querySelector('[data-rb-header]');

    function setHeaderState() {
        if (header) {
            header.classList.toggle('is-scrolled', window.scrollY > 28);
        }
    }

    setHeaderState();
    window.addEventListener('scroll', setHeaderState, {passive: true});

    const floatingRail = document.querySelector('[data-rb-floating-rail]');
    const railContext = document.querySelector('[data-rb-rail-context]');
    const railProgress = document.querySelector('[data-rb-rail-progress]');
    const railStory = [
        {id: 'hero', label: '把想法變成能賣的產品'},
        {id: 'reframe', label: '先決定該做什麼'},
        {id: 'possibilities', label: '一人公司需要的六種能力'},
        {id: 'team', label: '五位 AI 員工怎麼分工'},
        {id: 'proof', label: '我自己做過的作品'},
        {id: 'community', label: '和做產品的人一起學'},
        {id: 'deliver', label: '課程、搜尋與社群'},
        {id: 'pricing', label: '年費平均每月 NT$250'},
        {id: 'faq', label: '加入前的常見問題'}
    ];
    let railTicking = false;

    function updateFloatingRail() {
        if (!floatingRail) {
            railTicking = false;
            return;
        }

        const marker = window.scrollY + window.innerHeight * 0.38;
        let activeStory = railStory[0];
        railStory.forEach((story) => {
            const section = document.getElementById(story.id);
            if (section && section.offsetTop <= marker) {
                activeStory = story;
            }
        });

        floatingRail.classList.toggle('is-compact', window.scrollY > Math.min(720, window.innerHeight * 0.92));
        floatingRail.classList.toggle('is-conversion-zone', activeStory.id === 'pricing' || activeStory.id === 'faq');

        if (railContext && railContext.dataset.current !== activeStory.label) {
            railContext.dataset.current = activeStory.label;
            railContext.classList.add('is-changing');
            window.setTimeout(() => {
                railContext.textContent = activeStory.label;
                railContext.classList.remove('is-changing');
            }, reducedMotion ? 0 : 120);
        }

        if (railProgress) {
            const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
            const progress = Math.min(1, Math.max(0, window.scrollY / scrollable));
            railProgress.style.transform = `scaleX(${progress})`;
        }

        const floatY = reducedMotion ? 0 : Math.sin(window.scrollY / 620) * 7;
        const floatRotate = reducedMotion ? 0 : Math.sin(window.scrollY / 980) * 0.55;
        floatingRail.style.setProperty('--rb-float-y', `${floatY.toFixed(2)}px`);
        floatingRail.style.setProperty('--rb-float-rotate', `${floatRotate.toFixed(2)}deg`);
        railTicking = false;
    }

    window.addEventListener('scroll', () => {
        if (!railTicking) {
            window.requestAnimationFrame(updateFloatingRail);
            railTicking = true;
        }
    }, {passive: true});
    window.addEventListener('resize', updateFloatingRail);
    updateFloatingRail();

    const revealItems = Array.from(document.querySelectorAll('.rb-reveal'));
    if (reducedMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach(item => item.classList.add('is-visible'));
    } else {
        const revealObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, {rootMargin: '0px 0px -8% 0px', threshold: 0.08});

        revealItems.forEach((item, index) => {
            if (index < 7) {
                window.setTimeout(() => item.classList.add('is-visible'), index * 70 + 40);
            } else {
                revealObserver.observe(item);
            }
        });
    }

    const navLinks = Array.from(document.querySelectorAll('.rb-nav a[data-section]'));
    let navTicking = false;

    function updateActiveNav() {
        const marker = window.scrollY + 150;
        let activeLink = navLinks[0];

        navLinks.forEach((link) => {
            const section = document.getElementById(link.dataset.section);
            if (section && section.offsetTop <= marker) {
                activeLink = link;
            }
        });

        navLinks.forEach((link) => {
            const active = link === activeLink;
            link.classList.toggle('is-active', active);
            if (active) {
                link.setAttribute('aria-current', 'location');
            } else {
                link.removeAttribute('aria-current');
            }
        });

        navTicking = false;
    }

    window.addEventListener('scroll', () => {
        if (!navTicking) {
            window.requestAnimationFrame(updateActiveNav);
            navTicking = true;
        }
    }, {passive: true});
    window.addEventListener('resize', updateActiveNav);
    updateActiveNav();

    const scrollCopy = document.querySelector('.rb-scroll-copy');
    if (scrollCopy) {
        const text = scrollCopy.textContent.trim();
        const words = text.split(/\s+/);
        scrollCopy.textContent = '';

        words.forEach((word) => {
            const span = document.createElement('span');
            span.className = 'rb-word';
            span.textContent = word;
            scrollCopy.appendChild(span);
        });

        const wordElements = Array.from(scrollCopy.querySelectorAll('.rb-word'));
        let copyTicking = false;

        function updateWordReveal() {
            const rect = scrollCopy.getBoundingClientRect();
            const start = window.innerHeight * 0.9;
            const end = window.innerHeight * 0.24;
            const progress = reducedMotion ? 1 : Math.min(1, Math.max(0, (start - rect.top) / (start - end)));

            wordElements.forEach((word, index) => {
                const wordStart = index / wordElements.length;
                const wordProgress = Math.min(1, Math.max(0, (progress - wordStart) * wordElements.length));
                word.style.opacity = String(0.14 + wordProgress * 0.86);
                word.style.filter = `blur(${(1 - wordProgress) * 7}px)`;
            });

            copyTicking = false;
        }

        window.addEventListener('scroll', () => {
            if (!copyTicking) {
                window.requestAnimationFrame(updateWordReveal);
                copyTicking = true;
            }
        }, {passive: true});
        window.addEventListener('resize', updateWordReveal);
        updateWordReveal();
    }

    document.querySelectorAll('.rb-faq-item button').forEach((button) => {
        button.addEventListener('click', () => {
            const item = button.closest('.rb-faq-item');
            const answer = item.querySelector('.rb-faq-answer');
            const willOpen = button.getAttribute('aria-expanded') !== 'true';

            document.querySelectorAll('.rb-faq-item button').forEach((otherButton) => {
                const otherItem = otherButton.closest('.rb-faq-item');
                const otherAnswer = otherItem.querySelector('.rb-faq-answer');
                const otherIcon = otherButton.querySelector('i');
                otherButton.setAttribute('aria-expanded', 'false');
                otherAnswer.hidden = true;
                if (otherIcon) {
                    otherIcon.textContent = '＋';
                }
            });

            if (willOpen) {
                const icon = button.querySelector('i');
                button.setAttribute('aria-expanded', 'true');
                answer.hidden = false;
                if (icon) {
                    icon.textContent = '−';
                }
            }
        });
    });

    const carousel = document.querySelector('[data-team-carousel]');
    if (carousel) {
        const tabs = Array.from(carousel.querySelectorAll('[data-team-index]'));
        const panels = Array.from(carousel.querySelectorAll('[data-team-panel]'));
        const currentLabel = carousel.querySelector('[data-team-current]');
        const prevButton = carousel.querySelector('[data-team-prev]');
        const nextButton = carousel.querySelector('[data-team-next]');
        let activeIndex = 0;
        let timer = null;
        let paused = false;

        function restartProgress() {
            carousel.classList.remove('is-playing');
            void carousel.offsetWidth;
            if (!reducedMotion && !paused) {
                carousel.classList.add('is-playing');
            }
        }

        function scheduleNext() {
            window.clearTimeout(timer);
            restartProgress();
            if (!reducedMotion && !paused) {
                timer = window.setTimeout(() => setActive(activeIndex + 1), 7000);
            }
        }

        function setActive(index, focusTab) {
            activeIndex = (index + tabs.length) % tabs.length;
            tabs.forEach((tab, tabIndex) => {
                const active = tabIndex === activeIndex;
                tab.classList.toggle('is-active', active);
                tab.setAttribute('aria-selected', active ? 'true' : 'false');
                tab.tabIndex = active ? 0 : -1;
                if (active && focusTab) {
                    tab.focus({preventScroll: true});
                }
            });
            panels.forEach((panel, panelIndex) => {
                const active = panelIndex === activeIndex;
                panel.classList.toggle('is-active', active);
                panel.hidden = !active;
            });
            if (currentLabel) {
                currentLabel.textContent = String(activeIndex + 1).padStart(2, '0');
            }
            scheduleNext();
        }

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => setActive(index));
            tab.addEventListener('keydown', (event) => {
                if (event.key === 'ArrowRight') {
                    event.preventDefault();
                    setActive(activeIndex + 1, true);
                }
                if (event.key === 'ArrowLeft') {
                    event.preventDefault();
                    setActive(activeIndex - 1, true);
                }
            });
        });

        if (prevButton) {
            prevButton.addEventListener('click', () => setActive(activeIndex - 1));
        }
        if (nextButton) {
            nextButton.addEventListener('click', () => setActive(activeIndex + 1));
        }

        carousel.addEventListener('mouseenter', () => {
            paused = true;
            window.clearTimeout(timer);
            carousel.classList.remove('is-playing');
        });
        carousel.addEventListener('mouseleave', () => {
            paused = false;
            scheduleNext();
        });
        carousel.addEventListener('focusin', () => {
            paused = true;
            window.clearTimeout(timer);
            carousel.classList.remove('is-playing');
        });
        carousel.addEventListener('focusout', (event) => {
            if (!carousel.contains(event.relatedTarget)) {
                paused = false;
                scheduleNext();
            }
        });
        document.addEventListener('visibilitychange', () => {
            paused = document.hidden;
            if (paused) {
                window.clearTimeout(timer);
                carousel.classList.remove('is-playing');
            } else {
                scheduleNext();
            }
        });

        setActive(0);
    }

    const workVideos = Array.from(document.querySelectorAll('[data-work-video]'));
    if (!reducedMotion && 'IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const video = entry.target;
                if (entry.isIntersecting) {
                    const playAttempt = video.play();
                    if (playAttempt && typeof playAttempt.catch === 'function') {
                        playAttempt.catch(() => {});
                    }
                } else {
                    video.pause();
                }
            });
        }, {threshold: 0.55});

        workVideos.forEach(video => videoObserver.observe(video));
    }
}());
